import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { 
  FaPhone, 
  FaCalendarAlt,
  FaTruck,
  FaMusic,
  FaCheckCircle
} from 'react-icons/fa';
import { LuPiano } from "react-icons/lu";
import SeoHead from "../../components/Menu/components/SeoHead";
import '../../assets/css/aluguelpianos.css';

const galleryImages = [
  { id: 1, src: '/img/aluguel/1.jpg', alt: 'Aluguel para eventos',  },
  { id: 2, src: '/img/aluguel/2.jpg', alt: 'Aluguel para diversos prazos',  },
  { id: 3, src: '/img/aluguel/5.jpg', alt: 'Transporte especializado para pianos alugados', },
  { id: 5, src: '/img/aluguel/3.jpg', alt: 'Pianos de Cauda', },
  { id: 6, src: '/img/aluguel/4.jpg', alt: 'Pianos Verticais',  },

];

const aluguelPianosSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Aluguel de Pianos",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Waldir Pianos",
    "image": "https://pianoswaldir.com.br/images/logo.jpg", 
    "url": "https://pianoswaldir.com.br",
    "telephone": "+55-11-2256-5987",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Rua Waldemar Martins, 695", 
      "addressLocality": "São Paulo",
      "addressRegion": "SP",
      "postalCode": "02535-000", 
      "addressCountry": "BR"
    }
  },
  "name": "Aluguel de Pianos | Waldir Pianos",
  "description": "Aluguel de pianos de cauda e verticais para eventos, estudos e diversos prazos. Inclui transporte especializado e garantia de qualidade Waldir Pianos, com mais de 50 anos de experiência.",
  "areaServed": {
    "@type": "AdministrativeArea",
    "name": "São Paulo" 
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Opções de Aluguel de Pianos",
    "itemListElement": [
      {
        "@type": "OfferCatalog",
        "name": "Aluguel para Eventos",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Aluguel de Pianos de Cauda para Eventos"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Aluguel de Pianos Verticais para Eventos"
            }
          }
        ]
      },
      {
        "@type": "OfferCatalog",
        "name": "Aluguel por Prazo",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Aluguel de Pianos por Dia"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Aluguel de Pianos por Semana"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Aluguel de Pianos por Mês"
            }
          }
        ]
      }
    ]
  },
  "url": "https://pianoswaldir.com.br/aluguel-de-pianos",
  "image": "https://pianoswaldir.com.br/img/aluguel/1.jpg" 
};

const AluguelDePianos = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isHovered) {
        setCurrentImageIndex((prevIndex) => 
          (prevIndex + 1) % galleryImages.length
        );
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [isHovered]);

  const currentImage = galleryImages[currentImageIndex];

  return (
    <div className="aluguel-pianos-container">
      <SeoHead
  title="Aluguel de Pianos para Eventos e Estudos | Waldir Pianos"
  description="Alugue pianos de cauda e verticais para seu evento, estudo ou por tempo determinado. Inclui transporte especializado e garantia de qualidade Waldir Pianos. Solicite seu orçamento!"
  keywords="aluguel de pianos, alugar piano, piano para eventos, aluguel piano de cauda, aluguel piano vertical, piano para estudo, aluguel por dia, aluguel por mês, Waldir Pianos"
  image="/img/aluguel/1.jpg" 
  url="https://pianoswaldir.com.br/aluguel-de-pianos"
  canonicalUrl="https://pianoswaldir.com.br/aluguel-de-pianos"
  schemaMarkup={aluguelPianosSchema}
/>
      {/* Cabeçalho */}
      <motion.header 
        className="aluguel-header"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="aluguel-header-content">
          <motion.h1 
            className="aluguel-main-title"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            <LuPiano className="aluguel-title-icon" />
            Aluguel de Pianos
            <span className="aluguel-title-decoration"></span>
          </motion.h1>
          
          <motion.p 
            className="aluguel-header-subtitle"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            Música de qualidade para cada ocasião
          </motion.p>
        </div>
      </motion.header>

      {/* Conteúdo Principal */}
      <div className="aluguel-main-content">
        {/* Seção de Texto */}
        <motion.section 
          className="aluguel-text-section"
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.7 }}
        >
          <motion.div 
            className="aluguel-text-content"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
          >
            <h2 className="aluguel-section-title">
              <FaMusic className="aluguel-section-icon" />
              Solução Musical Completa
            </h2>
            
            <p className="aluguel-classic-text">
              "Seja para poucos dias em eventos ou por meses para estudo. Oferecemos a opção de aluguel de Pianos de cauda e verticais."
            </p>
            
            <div className="aluguel-modern-text">
              <p>Com transporte especializado e toda garantia de qualidade de mais de 56 anos de conhecimento.</p>
              
              <p>Nossos pianos são cuidadosamente selecionados e mantidos para oferecer a melhor experiência musical.</p>
            </div>
            
            <div className="aluguel-benefits-grid">
              <div className="aluguel-benefit-item">
                <FaCalendarAlt className="aluguel-benefit-icon" />
                <span>Locação por dia, semana ou mês</span>
              </div>
              <div className="aluguel-benefit-item">
                <FaTruck className="aluguel-benefit-icon" />
                <span>Transporte especializado incluído</span>
              </div>
              <div className="aluguel-benefit-item">
                <FaCheckCircle className="aluguel-benefit-icon" />
                <span>Garantia de qualidade e afinação</span>
              </div>
            </div>
          </motion.div>
        </motion.section>

        {/* Galeria */}
        <motion.section 
          className="aluguel-gallery-section"
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.7 }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <h3 className="aluguel-gallery-title">Pianos para Aluguel</h3>
          
          <motion.div 
            className="aluguel-gallery-container"
            key={currentImageIndex}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            <div className="aluguel-piano-image">
              <img 
                src={currentImage.src} 
                alt={currentImage.alt}
                className="aluguel-gallery-image"
              />
              <div className="aluguel-image-overlay">
                <span className="aluguel-piano-description">{currentImage.alt}</span>
              </div>
            </div>
          </motion.div>
          
          <div className="aluguel-gallery-dots">
            {galleryImages.map((_, index) => (
              <button
                key={index}
                className={`aluguel-dot ${index === currentImageIndex ? 'aluguel-dot-active' : ''}`}
                onClick={() => setCurrentImageIndex(index)}
              />
            ))}
          </div>
        </motion.section>
      </div>

      {/* Rodapé */}
      <motion.footer 
        className="aluguel-footer"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2 }}
      >
        <p className="aluguel-footer-text">Solicite um orçamento sem compromisso</p>
        <motion.a
          href="tel:1122565987"
          className="aluguel-contact-button"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <FaPhone /> Fale Conosco
        </motion.a>
      </motion.footer>
    </div>
  );
};

export default AluguelDePianos;